var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-2 text-sm text-white bg-indigo-400 cursor-pointer hover:bg-indigo-700",on:{"click":function($event){return _vm.goTo(_vm.place)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }